var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.users),function(u){return _c('div',{key:u.id,staticClass:"user-data-row-container flex-space-between--center"},[_c('UserDataRow',{attrs:{"user":u,"isShowEmail":"","userData":_vm.userShareData(u),"me":_vm.me,"projectId":_vm.projectId}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }